import React from 'react';
import { useSearchParams } from 'react-router-dom';
import ListaClienti from '../../components/staff/ListaClienti';

// /admin/clienti: la lista completa dei clienti (stesse righe di Oggi), con i filtri dall'indirizzo (?fermi=1, ?fase=)
const Clienti = () => {
  const [params] = useSearchParams();
  return (
    <main className="st wrap" data-testid="pagina-clienti">
      <ListaClienti titolo="Clienti" fermiIniziale={params.get('fermi') === '1'} faseIniziale={params.get('fase') || ''} />
    </main>
  );
};

export default Clienti;
